export default function CloseCircledIcon({ color = "currentColor", size = 13 }: { color?: string; size?: number }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 13 13" fill="none">
      <path
        d="M12 6.5C12 5.77773 11.8577 5.06253 11.5813 4.39524C11.3049 3.72795 10.8998 3.12164 10.3891 2.61091C9.87837 2.10019 9.27205 1.69506 8.60476 1.41866C7.93747 1.14226 7.22227 1 6.5 1C5.77773 1 5.06253 1.14226 4.39524 1.41866C3.72795 1.69506 3.12164 2.10019 2.61091 2.61091C2.10019 3.12163 1.69506 3.72795 1.41866 4.39524C1.14226 5.06253 1 5.77773 1 6.5C1 7.95869 1.57946 9.35764 2.61091 10.3891C3.64236 11.4205 5.04131 12 6.5 12C7.95869 12 9.35764 11.4205 10.3891 10.3891C11.4205 9.35764 12 7.95869 12 6.5Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M5 5L8 8" stroke={color} strokeLinecap="round" />
      <path d="M8 5L5 8" stroke={color} strokeLinecap="round" />
    </svg>
  );
}
